import { createContext, useContext } from 'react'

export type ProfileLayoutMode = 'mobile' | 'tablet' | 'desktop'

export const getProfileLayoutMode = (width: number): ProfileLayoutMode => {
  if (width < 600) return 'mobile'
  if (width < 1000) return 'tablet'
  return 'desktop'
}

export interface ProfileLayoutData {
  layoutMode: ProfileLayoutMode
  width: number
  height: number
  // true while an encounter form is open — profile chrome (assessment header row, profile
  // tab bar) is hidden so the form gets the full height. Set from the charting view.
  focusMode: boolean
  setFocusMode: (on: boolean) => void
  sidebar: {
    // drawer state, used when the sidebar is not in flow (mobile / unpinned tablet)
    isOpen: boolean
    onOpen: () => void
    onClose: () => void
    canPin: boolean
    isPinned: boolean
    setPinned: (pinned: boolean) => void
  }
}

// Desktop no-op default so consumers rendered outside the provider (V1) behave as before
export const ProfileLayoutContext = createContext<ProfileLayoutData>({
  layoutMode: 'desktop',
  width: 0,
  height: 0,
  focusMode: false,
  setFocusMode: () => {},
  sidebar: {
    isOpen: false,
    onOpen: () => {},
    onClose: () => {},
    canPin: false,
    isPinned: true,
    setPinned: () => {},
  },
})

export const useProfileLayout = () => useContext(ProfileLayoutContext)
